module.exports = __webpack_public_path__ + "img/desc.37fc7eb8.png";